import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=0bf6ee44&"
import script from "./Supplier.vue?vue&type=script&lang=js&"
export * from "./Supplier.vue?vue&type=script&lang=js&"
import style0 from "./Supplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports